import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ErrorPage from "../../components/ErrorPage";

const NewCryptoPageLayout = () => {
  const clientInfo = useSelector((state) => state.client.clientInfo);
  // TODO: Need to remove this check
  return (
    <>
      {clientInfo?.enable_new_crypto ? (
        <Outlet />
      ) : (
        <ErrorPage
          errorCode="403"
          message="Forbidden"
          description="You don't have permission to access this resource"
        />
      )}
    </>
  );
};

export default NewCryptoPageLayout;